/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Alarms_Import_Error_EmptyInputs */



/**
* | output |
* | --- |
* | "No valid alarms found in the file." |
*
* @param {Alarms_Import_Error_EmptyInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const alarms_import_error_empty = /** @type {((inputs?: Alarms_Import_Error_EmptyInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Alarms_Import_Error_EmptyInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("No valid alarms found in the file.")
	return /** @type {LocalizedString} */ ("Aucune alarme valide trouvée dans le fichier.")
});